module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subIBReport"
  }, [_vm._v("\n    ====================》这是subIBReport页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5008df7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/subIBReport.vue
// module id = 1165
// module chunks = 1